<template>
  <div  class="vue_body_min_height" style="padding-bottom: 50px;">
    <img v-if="currentBanner != null" :src="currentBanner.url" style="width: 100%;">

    <div id="match_head_outer" v-if="match != null">
      <div class="title">{{match.title}}</div>
      <div class="desc">{{match.subtitle}}</div>
    </div>

    <div id="match_list_sub_menus" class="container">
      <a href="javascript:void(null);"
         v-for="(item, index) in subList"
         :class="tabIndex == index ? 'active' : ''"
         @click="subMenuClicked(index)"
         :key="'match_list_menu_' + index">{{item}}</a>
    </div>

    <div v-if="tabIndex == 1" class="container">
      <match-detail-news v-bind:tagName="match.title" ></match-detail-news>
    </div>

    <div id="match_list_outer" v-else-if="matchDivisions != null && matchDivisions.length > 0" class="container" style="text-align: center;">
      <div class="item"
           v-for="(item, index) in matchDivisions"
           @click="matchItemClicked(index)"
           :key="'match_list_index_' + index">
        <div class="left" >
          <el-image fit="cover" :src="item.imageUrl" ></el-image>
          <span class="title" >{{item.title}}</span>
        </div>
        <div class="arrow iconfont" >&#xe611;</div>
      </div>
    </div>

  </div>
</template>

<script>
  import MatchDetailNews from "../components/matches/MatchDetailNews";
export default {
  name: "MatchListPage",
  components: {MatchDetailNews},
  data() {
    return {
      matchDivisions: [
        ],
      match: {
      },
      subList: [
        '赛事组别',
        '动态'
      ],
      tabIndex: 0,
      addActivities: false,
    }
  },

  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    id() {
      return this.$route.params.id;
    },
    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'matches';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    dealWithShareObj() {
      let shareObj = this.$store.state.http.defaultShareObj;
      shareObj.title = this.match.title;
      shareObj.link = location.href;
      this.configShareWx(encodeURIComponent(location.href), shareObj);
    },

    loadActivitiesData() {
      if (this.match == null) {
        return;
      }
      let tag = ((this.match.title == undefined || this.match.title == null) ? '' : this.match.title).removeBlanks();
      let params = {
        pageIndex: 1,
        size: 1,
        tag: tag,
      };
      let _this = this;
      this.$store.state.http.ajax.matchDeatilList(params,function (data) {
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          if (newList.length > 0) {
            _this.addActivities = true;
          }
          _this.dealWithTabs();
          return;
        }
        _this.dealWithTabs();
      },function (data) {
        _this.dealWithTabs();
      });
    },

    dealWithTabs() {
      let list = ['赛事组别'];
      if (this.addActivities) {
        list.push('动态');
      }
      this.subList = list;
    },

    loadData() {
      let id= this.id;
      if (id == undefined) {
        return;
      }
      let params = {
        matchId: id
      };
      let _this = this;
      this.httpManager.ajax.mdDivision(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.match = data.data.match;
          _this.matchDivisions = data.data.matchDivisions;
          _this.loadActivitiesData();
          _this.dealWithShareObj();
          return;
        }
        _this.$toast('请求失败！');
      }, function (data) {
        _this.$toast('请求失败，请重试！');
      })
    },

    subMenuClicked(index) {
      this.tabIndex = index;
    },

    matchItemClicked(index) {
      let item = this.matchDivisions[index];

      //...
      let href = this.$router.resolve({
        name: 'matchDetailPage',
        params: {
          id: item.id
        },
        query: {
          md: 1
        }
      }).href;
      window.open(href, '_blank');
    }
  },

}
</script>

<style scoped>

  #match_list_outer {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 30px 15px;
    margin-top: 30px;
  }

  #match_head_outer {
    text-align: center;
  }
  #match_head_outer .title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 40px;
  }

  #match_head_outer .desc {
    font-size: 1rem;
    color: #999;
    margin-top: 10px;
  }

  #match_list_outer .item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  #match_list_outer .item:not(:first-child) {
    margin-top: 20px;
  }

  #match_list_outer .item .left {
    width: 80%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;

  }

  #match_list_outer .item .left .el-image {
    width: 20%;
  }

  #match_list_outer .item .left .title {
    padding-left: 15px;
    width: 80%;
    text-align: left;
    font-weight: bold;
    font-size: 1.3rem;
  }

  #match_list_outer .item .arrow {
    width: 10%;
    margin-left: 5%;
    font-size: 1.5rem;
    text-align: right;
  }

  @media screen and (min-width: 768px) {

    #match_list_outer .item .left {
      width: 92%;
    }

    #match_list_outer .item .left .el-image {
      width: 15%;
    }

    #match_list_outer .item .left .title {
      width: 85%;
    }
    #match_list_outer .item .arrow {
      width: 5%;
      margin-left: 3%;
      text-align: right;
    }
  }

  #match_list_sub_menus {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }

  #match_list_sub_menus > a {
    color: #333;
    text-decoration: none;
    font-weight: bold;
    font-size: 1rem;
  }

  #match_list_sub_menus > a.active {
    color: #fc1a34;
    pointer-events: none;
  }


</style>



// WEBPACK FOOTER //
// src/pages/MatchListPage.vue